export const ENTER = 13;

const keyCode = {
  ENTER,
};

export default keyCode;
